import React from 'react'
import { Navigate } from 'react-router'
import { useDispatch } from 'react-redux'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { spacing } from '@mobi/component-library/Foundations'
import { Toggle } from '@mobi/component-library/Selection&Input/Toggle'
import { List, ListItem } from '@mobi/component-library/Base/List'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { useAppSelector } from '@core/Store/hooks'
import { MainContainer } from '@core/Components/Containers'
import { useServerConfig } from '@core/Data/ServerConfig/useServerConfig'
import { toggleKambiLogging, toggleReactQueryDevTools } from './Store'
import {
  VersionInfo,
  CookieManagement,
  CookieInfo,
  LocalStorageManager,
  LastPaymentMethod,
  Sentry,
  GeoLocation,
  Notifications,
  FeatureToggles,
} from './Components'

export const Toolbox = () => {
  const toolboxElRef = React.useRef<HTMLDivElement>(null)
  const serverConfig = useServerConfig()
  const dispatch = useDispatch()

  const isReactQueryDevToolsEnabled = useAppSelector(
    state => state.toolbox.isReactQueryDevToolsEnabled
  )
  const isKambiLoggingEnabled = useAppSelector(state => state.toolbox.isKambiLoggingEnabled)

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  if (!serverConfig) return null
  if (serverConfig.isInternalRequest === false) return <Navigate to='/' />

  return (
    <>
      <PageHeader title='Development Toolbox' />

      <MainContainer
        style={{ padding: `${spacing.smx1} ${spacing.md}` }}
        background='surface300'
        ref={toolboxElRef}
      >
        <Flex flexDirection='column' gap={spacing.md}>
          <VersionInfo />

          <List title='Dev Toggles' variant='card'>
            <ListItem
              text='React Query DevTools'
              contentRight={
                <Toggle
                  id='react-query-dev'
                  onToggle={() => dispatch(toggleReactQueryDevTools())}
                  isOn={isReactQueryDevToolsEnabled}
                />
              }
            />
            <ListItem
              text='Kambi Console Logging'
              contentRight={
                <Toggle
                  id='kambi-console'
                  onToggle={() => dispatch(toggleKambiLogging())}
                  isOn={isKambiLoggingEnabled}
                />
              }
            />
          </List>

          <FeatureToggles />

          <List title='Cookie Management' itemSize='dynamic' variant='card'>
            <ListItem content={<CookieInfo />} />
            <ListItem content={<CookieManagement />} />
          </List>

          <List title='Other' variant='card'>
            <List itemSize='dynamic'>
              <ListItem content={<GeoLocation />} />
              <ListItem content={<Notifications />} />
              <ListItem content={<LocalStorageManager />} />
              <ListItem content={<LastPaymentMethod />} />
              <ListItem content={<Sentry />} />
            </List>
          </List>
        </Flex>
      </MainContainer>
    </>
  )
}
